import React, { useEffect, useState } from "react";
import { Container, Typography, Box, Paper, Grid, Button } from "@mui/material";
import { useAuth } from "../../contexts/AuthContext";
import { useNavigate } from "react-router-dom";
import { db } from "../../firebase";
import { collection, getDocs, query, where } from "firebase/firestore";


const SuperAdminDashboard = () => {

    const { user, isSuperAdmin } = useAuth();
    const navigate = useNavigate();

    const [tenantCount, setTenantCount] = useState(0);
    const [appAdminCount, setAppAdminCount] = useState(0);

    useEffect(() => {
        if (!user || !isSuperAdmin()) {
            navigate("/login");
            return;
        }

        const fetchData = async () => {
            try {
                // Tenants
                const tenantsSnapshot = await getDocs(collection(db, "tenantmaster"));
                setTenantCount(tenantsSnapshot.size);

                // App Admins
                const appAdminsQuery = query(
                    collection(db, "users"),
                    where("role", "==", "appadmin")
                );
                const appAdminsSnapshot = await getDocs(appAdminsQuery);
                setAppAdminCount(appAdminsSnapshot.size);

            } catch (err) {
                console.error(err);
            }
        };

        fetchData();
    }, [user]);

    return (
        <Box sx={{
            minHeight: "100vh",
            width: "100%",
            backgroundColor: "#fefce8",
            py: 4
        }}>

            <Container maxWidth="lg">


                {/* HEADER */}
                <Box sx={{ mb: 4 }}>
                    <Typography
                        variant="h4"
                        sx={{
                            fontWeight: 900,
                            fontFamily: "'Unbounded', sans-serif",
                            color: "#1c1400"
                        }}
                    >
                        Super Admin Dashboard
                    </Typography>

                    <Typography sx={{ color: "#8a7a40" }}>
                        Welcome, {user?.userName || user?.email}
                    </Typography>
                </Box>

                {/* ANALYTICS CARDS */}
                <Grid container spacing={3}>

                    {/* Tenants */}
                    <Grid item xs={12} md={6}>
                        <Paper sx={{
                            p: 4,
                            borderRadius: "14px",
                            border: "2px solid #f0d060",
                            background: "#ffffff"
                        }}>
                            <Typography sx={{ color: "#8a7a40" }}>
                                Total Organizations
                            </Typography>
                            <Typography sx={{
                                fontSize: "2rem",
                                fontWeight: 800,
                                color: "#1c1400"
                            }}>
                                {tenantCount}
                            </Typography>
                        </Paper>
                    </Grid>

                    {/* App Admins */}
                    <Grid item xs={12} md={6}>
                        <Paper sx={{
                            p: 4,
                            borderRadius: "14px",
                            border: "2px solid #f0d060",
                            background: "#ffffff"
                        }}>
                            <Typography sx={{ color: "#8a7a40" }}>
                                Org Admins
                            </Typography>
                            <Typography sx={{
                                fontSize: "2rem",
                                fontWeight: 800,
                                color: "#1c1400"
                            }}>
                                {appAdminCount}
                            </Typography>
                        </Paper>
                    </Grid>

                </Grid>

                <Box sx={{ mt: 4 }}>
                    <Paper sx={{
                        p: 4,
                        borderRadius: "14px",
                        border: "2px solid #f0d060",
                        background: "#ffffff",
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center"
                    }}>

                        <Box>
                            <Typography sx={{ fontWeight: 700, color: "#1c1400" }}>
                                Organization Management
                            </Typography>

                            <Typography sx={{ color: "#8a7a40", fontSize: "0.9rem" }}>
                                Create and manage Organizations and assign administrators.
                            </Typography>
                        </Box>

                        <Button
                            variant="contained"
                            sx={{
                                background: "#1c1400",
                                color: "#fde047",
                                "&:hover": {
                                    background: "#f59e0b",
                                    color: "#1c1400"
                                }
                            }}
                            onClick={() => navigate("/host-management")}
                        >
                            Manage Organizations
                        </Button>

                    </Paper>
                </Box>

                {/* INFO SECTION */}
                <Box sx={{ mt: 4 }}>
                    <Paper sx={{
                        p: 3,
                        borderRadius: "12px",
                        background: "#fffbea",
                        border: "1px solid #f0d060"
                    }}>
                        <Typography>
                            As a Super Admin, you can manage Organizations and assign administrators.
                            Facility and user management is handled at the admin level.
                        </Typography>
                    </Paper>
                </Box>

            </Container>
        </Box>
    );
};

export default SuperAdminDashboard;